import {createSlice} from "@reduxjs/toolkit";

const initialAccessGroupsState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    accessGroupForEdit: undefined,
    lastError: null
};

export const callTypes = {
    list: "list",
    action: "action"
}

export const accessGroupsSlice = createSlice({
    name: "accessGroups",
    initialState: initialAccessGroupsState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        // getAccessGroupById
        accessGroupFetched: (state, action) => {
            state.actionsLoading = false;
            state.accessGroupForEdit = action.payload.accessGroupForEdit;
            state.error = null;
        },
        // findAccessGroups | getAllAccessGroups
        accessGroupsFetched: (state, action) => {
            const {totalCount, entities} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        // createAccessGroup
        accessGroupCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(action.payload.accessGroup);
        },
        // updateAccessGroup
        accessGroupUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.map(entity => {
                if (entity.id === action.payload.accessGroup.id) {
                    return action.payload.accessGroup;
                }
                return entity;
            })
        },
        // deleteAccessGroup
        accessGroupDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.filter(el => el.id !== action.payload.id);
        }

    }
})